import { ProjectCard } from "@/components/organisms/ProjectCard";
import { useBudouX } from "@/hooks/useBudouX";
import clsx from "clsx";

export const ProjectNav = ({ className }) => {
  const { parse } = useBudouX();
  return (
    <>
      <section
        className={clsx(
          className,
          "mx-auto grid  grid-cols-2 gap-2 px-6 sm:px-8 md:grid-cols-3 md:gap-6 md:px-12 xl:px-0"
        )}
      >
        <ProjectCard
          id="1"
          href="/project/1"
          title="調査から着手した電子マネーの設計･開発。数年に及ぶ長期プロジェクト"
          src="/project-thumbnail1.webp"
          className="col-span-2 md:col-span-1"
          tag={["Digital Products", "Infra Structure", "AWS"]}
        />
        <ProjectCard
          id="2"
          href="/project/2"
          title="ペーパーからクラウドへ。最適な設計とシステムのご提案。"
          src="/project-thumbnail2.webp"
          className="col-span-1"
          tag={["Digital Solution", "User Experience"]}
        />
        <ProjectCard
          id="3"
          href="/project/3"
          title="1つの要件で考えない。お客さまと共に見つけ出す、課題の解決法。"
          src="/project-thumbnail3.webp"
          className="col-span-1"
          tag={["Cloud", "Paperless", "SpeedCMS"]}
        />
      </section>
    </>
  );
};
